import React from "react";
import invitationReducer from "../reducers/invitation";
import { invitation, requestState } from "../actions";
import axios from "axios";
const InvitationContext = React.createContext();
export const InvitationProvider = ({ children }) => {
	const initialState = {
		invitations: null,
		referreds: null,
		loading: false,
		error: null,
		success: null,
		code: localStorage.getItem('code'),
	};

	const [invitationState, dispatch] = React.useReducer(invitationReducer, initialState);

	const isLoading = () => {
		dispatch({
			type: requestState.LOADING,
		});
	};

	/*const getInvitationCode = async (id) => {
		try {
			const res = await axios.get("/referral", {
				params: {
					user: id,
				},
			});
			dispatch({
				type: invitation.GET_REFERREDS,
				payload: res.data.code,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};*/
	const getInvitations = async () => {
		isLoading();
		try {
			const res = await axios.get("/invitations");
			const codeReq = await axios.get("/referral");
			const refReq = await axios.get("/referreds");
			dispatch({
				type: invitation.GET_INVITATIONS,
				payload: {
					invitations: res.data,
					code: codeReq.data.code,
					referreds: refReq.data,
				},
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message :  error.message,
			});
		}
	};

	/*	const getReferreds = async (id) => {
		try {
			const res = await axios.get("/referreds", {
				params: {
					referrer: id,
				},
			});
			dispatch({
				type: invitation.GET_REFERREDS,
				payload: res.data,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};*/

	const sendInvitation = async (data) => {
		isLoading();
		try {
			await axios.post("/invitations", data);
			dispatch({
				type: invitation.SEND_INVITATION,
				payload: data.name,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};

	// Clear Errors
	const clearNotification = () =>
		dispatch({
			type: requestState.CLEAR_NOTIFICATION,
		});
	return (
		<InvitationContext.Provider
			value={{
				loading: invitationState.loading,
				error: invitationState.error,
				clearNotification: clearNotification,
				isLoading: isLoading,
				success: invitationState.success,
				getInvitations: getInvitations,
				invitations: invitationState.invitations,
				referreds: invitationState.referreds,
				sendInvitation: sendInvitation,
				code : invitationState.code
			}}
		>
			{children}
		</InvitationContext.Provider>
	);
};

export const useInvitationContext = () => React.useContext(InvitationContext);
